// app/frontend/controllers/location_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phoneInput", "locationConsent", "thingId", "extraId"]

  connect() {
    console.log("📍 LocationController connected")
  }

  submitLocation(event) {
    event.preventDefault()

    const phoneNumber = this.phoneInputTarget.value.trim()
    const thingId = this.hasThingIdTarget ? this.thingIdTarget.value : null
    const extraId = this.hasExtraIdTarget ? this.extraIdTarget.value : null
    const locationAuthorized = this.hasLocationConsentTarget && this.locationConsentTarget.checked

    if (!phoneNumber) {
      alert("📞 Please enter a callback number.")
      return
    }

    if (!locationAuthorized) {
      alert("⚠️ Please authorize sharing your callback number and current location with 313.cash/tow dispatch.")
      return
    }

    if (!navigator.geolocation) {
      alert("🌐 Geolocation is not supported by your browser.")
      return
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude } }) => {
        fetch("/geocoders/create_invoice", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          },
          body: JSON.stringify({
            latitude,
            longitude,
            phone_number: phoneNumber,
            thing_id: thingId,
            extra_id: extraId,
            location_authorized: locationAuthorized,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              alert("✅ Your request was sent successfully!")
            } else {
              alert(`❌ Error: ${data.error}`)
            }
          })
          .catch((error) => {
            console.error("❌ Request error:", error)
            alert("💥 An error occurred while sending your request.")
          })
      },
      (error) => {
        alert(`📍 Error fetching location: ${error.message}`)
      }
    )
  }
}
